export const getAccordionStyles = (
  dynamicColors: typeof DynamicColors.default
): Record<string, any> => ({
  wrapperStyles:
    'w-full h-auto mx-auto pt-8 pb-8 px-8 lg:pr-20 lg:pl-12 lg:py-28 ',
  headlineWrapper: `w-full headline-h2 py-8 text-left break-words ${dynamicColors.text} md:text-36`
})

export const ImageLeftStyle: Record<string, any> = {
  mainImageWrapper: 'w-1/2 float-left pr-10 lg:pr-20',
  accordionItemsWrapper: 'lg:w-1/2 lg:float-right lg:relative lg:pl-20'
}

export const ImageRightStyle: Record<string, any> = {
  mainImageWrapper: 'w-1/2 float-right pl-10 lg:pl-20',
  accordionItemsWrapper: 'lg:w-1/2 lg:float-left lg:relative lg:pr-20'
}

export const getAccordionItemsStyles = (
  dynamicColors: typeof DynamicColors.default
): Record<string, any> => ({
  accordionItemsWrapper: 'lg:relative lg:pr-20',
  buttonStyle: `text-12 flex flex-row justify-between min-h-fit tracking-4 uppercase w-full py-8 text-left ${dynamicColors.menu.close} border-t ${dynamicColors.line.close}`,
  openButtonStyle: `text-12 flex flex-row justify-between min-h-fit tracking-4 uppercase w-full py-8 text-left ${dynamicColors.menu.open} border-t ${dynamicColors.line.open}`,
  panelStyle: `text-left ${dynamicColors.text} text-justify text-16 tracking-0.6 leading-28 w-full pb-8`,
  openPanelStyle: `text-left ${dynamicColors.text} text-justify text-16 tracking-0.6 leading-28 w-full pb-8 openPanel`,
  mobileImageWrapper: 'w-full pt-12 pb-3 imageWrapper',
  separatorWrapper: 'w-full',
  separator: `border-t ${dynamicColors.line.close}`
})

export const DynamicColors = {
  default: {
    text: 'text-black',
    menu: { close: 'text-menuFooterGray ', open: 'text-black' },
    line: { close: 'border-gray214', open: 'border-black' },
    arrow: { open: 'fill-grayRegular', close: 'fill-grayRegular' }
  },
  white: {
    text: 'text-black',
    menu: { close: 'text-iconBlack ', open: 'text-black' },
    line: { close: 'border-gray214', open: 'border-iconBlack' },
    arrow: { open: 'fill-grayRegular', close: 'fill-grayRegular' }
  },
  black: {
    text: 'text-white',
    menu: { close: 'text-white ', open: 'text-lightGray' },
    line: { close: 'border-white', open: 'border-grayRegular' },
    arrow: { open: 'fill-white', close: 'fill-grayRegular' }
  },
  jasmin_darkGreen: {
    text: 'text-white',
    menu: { close: 'text-white ', open: 'text-lightGray' },
    line: { close: 'border-white', open: 'border-grayRegular' },
    arrow: { open: 'fill-white', close: 'fill-grayRegular' }
  },
  jasmin_lightGreen: {
    text: 'text-black',
    menu: { close: 'text-black', open: 'text-black' },
    line: { close: 'border-white', open: 'border-grayRegular' },
    arrow: { open: 'fill-grayRegular', close: 'fill-grayRegular' }
  },
  jasmin_lightGray: {
    text: 'text-black',
    menu: { close: 'text-black ', open: 'text-black' },
    line: { close: 'border-grayRegular', open: 'border-iconBlack' },
    arrow: { open: 'fill-grayRegular', close: 'fill-grayRegular' }
  }
}
